<mat-toolbar color="accent">
  <mat-toolbar-row>
    <span>NgProviders</span>

    <span fxFlex></span>

    <button mat-button routerLink="">Root</button>
    <button mat-button routerLink="mod1">Module 1</button>
    <button mat-button routerLink="mod1/submod1">SubModule 1</button>
    <button mat-button routerLink="mod2">Module 2</button>
  </mat-toolbar-row>
</mat-toolbar>

<div fxFlexFill fxLayout="row" fxLayoutAlign="center center">

  <router-outlet></router-outlet>

</div>
